const riot = require('riot');

riot.tag2('page-admin-deposit_history-edit', '<div class="s-full f"> <div data-is="module-sidebar"></div> <div class="s-full bg-gray_light_10"> <form class="s-full f fclm p40" if="{!isLoading}" ref="form" onsubmit="{onSubmit}" oninput="{onInput}"> <div class="mb20"><a class="f fm text-gray_dark_20 mb4" href="/admin/companies/{id}"><i class="material-icons">navigate_before</i> <div class="ts-h5">{company.name}詳細</div></a> <div class="f fm w-full"> <div class="ts-h2 w-full">入金履歴の{isNew ? ⁗追加⁗ : ⁗編集⁗}</div> <button class="button error flex-fixed" if="{!isNew}" type="button" onclick="{onClickDelete}">削除</button> </div> </div> <div class="f fclm p20 bg-white"> <div class="border-bottom border-gray_light_10 pb16 mb16"> <label class="block mb20"> <div class="ts-h5 mb4">取引タイプ</div> <div class="w160" data-is="atom-input-select" name="deal_type" options="{app.data.constants.point_deposit_history_deal_types}" required riot-value="{history.deal_type}"></div> </label> <label class="block mb20"> <div class="ts-h5 mb4">金額</div> <input class="input w160" type="text" name="amount" required riot-value="{history.amount}" placeholder="100" pattern="^[0-9]+$" data-message="整数を入力してください" oninvalid="{onInvalid}" autocomplete="off"> </label> <label class="block mb20"> <div class="ts-h5 mb4">反映日</div> <input class="input" name="apply_at" required riot-value="{dayjs(history.apply_at).format(&quot;YYYY-MM-DD&quot;)}" type="{\'date\'}"> </label> <label class="block"> <div class="ts-h5 mb4">コメント</div> <div class="ts-caption text-gray_dark_20 mb4">必要に応じて入力してください(任意)</div> <textarea class="input w-full min-height-82" name="reason" placeholder="コメントを入力" riot-value="{history.reason}"></textarea> </label> </div> <div class="f fr"> <button class="button primary">保存</button> </div> </div> </form> </div> </div>', 'page-admin-deposit_history-edit,[data-is="page-admin-deposit_history-edit"]{display:block}', '', function(opts) {

    this.isLoading = true;

    this.preload = async ({req, res}) => {
      if (spat.isNode) return;
      app.utils.auth.validateOperator();

      this.isLoading = true;
      this.update();

      const { id, history_id } = req.params;
      const promises = [
        app.api.child('companies').child(id).get()
      ];
      const isNew = history_id === 'new';
      if (!isNew) {
        promises.push(app.api.child(`companies/${id}/point_deposit_histories/${history_id}`).get());
      }
      const [{company}, {point_deposit_history} = {}] = await Promise.all(promises);
      this.history = point_deposit_history;

      return {
        id,
        company,
        historyId: history_id,
        isLoading: false,
        isNew,
      };
    };

    this.on('show', () => {
      this.isChange = false;
    });

    this.on('beforeunload', (e) => {
      if (this.isChange) {
        e.returnValue = app.data.beforeunload_text;
      }
    });

    this.onSubmit = async (e) => {
      e.preventDefault();
      var indicator = spat.modal.indicator();
      const query = [...this.refs.form.elements].reduce((query, input) => {
        query[input.name] = input.value;
        return query;
      }, {});
      query.apply_at = dayjs(query.apply_at).valueOf();
      query.amount = Number(query.amount);
      try {
        if (this.isNew) {
          var {point_deposit_history} = await app.api.child(`companies/${this.id}/point_deposit_histories`).post(query);
          spat.modal.alert('入金履歴を追加しました。');
        }
        else {
          var {point_deposit_history} = await app.api.child(`companies/${this.id}/point_deposit_histories/${this.historyId}`).put(query);
          spat.modal.alert('入金履歴を編集しました。');
        }
        this.isChange = false;
        spat.router.push(`/admin/companies/${this.id}`);
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.changeData = () => {
      this.isChange = true;
    };

    this.onClickDelete = async () => {
      const ok = await spat.modal.open('modal-confirm', {
        title: '入金履歴を削除しますか?',
        text: '削除した場合、二度と元に戻すことは出来ません。\nまた、この入金履歴は顧客企業の画面にも即座に反映されます。\n本当に削除をしますか？',
        positive: '削除',
      }).waitClose();
      if (ok) {
        this.isChange = false;
        const indicator = spat.modal.indicator();

        try {
          await app.api.child(`companies/${this.id}/point_deposit_histories/${this.historyId}`).del({});
          spat.toast.message('入金履歴を削除しました');

          spat.router.push(`/admin/companies/${this.id}`);
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
        finally {
          indicator.close();
        }
      }
    };

    this.onInvalid = (e) => {
      e.preventUpdate = true;
      if (e.target.dataset.message) {
        e.target.setCustomValidity(e.target.dataset.message);
      }
    };

    this.onInput = (e) => {
      e.preventUpdate = true;
      e.target.setCustomValidity('');
      this.changeData();
    };
});